import { render, staticRenderFns } from "./goods-columns-active.vue?vue&type=template&id=134fd636&scoped=true&"
import script from "./goods-columns-active.vue?vue&type=script&lang=js&"
export * from "./goods-columns-active.vue?vue&type=script&lang=js&"
import style0 from "./goods-columns-active.vue?vue&type=style&index=0&id=134fd636&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134fd636",
  null
  
)

export default component.exports